<div class="page-platform-settings">
  <div class="row">
    <div class="col">
      <fx-page-header title="Platform Settings"></fx-page-header>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <fx-wallet [permission]="permission"></fx-wallet>
    </div>
  </div>
</div>
